import type { Vault } from '@/types/vault'

export function isVaultInTvlRange(vault: Vault, range: [number, number]): boolean {
  if (!vault.tvl.usd) return false

  const unifiedTvl = Number(vault.tvl.usd)
  return unifiedTvl >= range[0] && unifiedTvl <= range[1]
}
